// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionFilter_container__2yi1F","search":"SessionFilter_search__3d-NF"};